import { render, staticRenderFns } from "./company-credit-transactions.vue?vue&type=template&id=759018c1&"
import script from "./company-credit-transactions.ts?vue&type=script&lang=ts&"
export * from "./company-credit-transactions.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports